package diana.soleil.design.iraniancanadienbazzar.feature.events

import org.koin.core.module.dsl.viewModel
import org.koin.dsl.module

val eventsModule = module {
    viewModel { EventsViewModel(get(), get(), get()) }
    viewModel { (eventId: String) -> EventDetailViewModel(get(), get(), eventId) }
    viewModel { (eventId: String) -> EventTicketsViewModel(get(), get(), get(), eventId) }
    viewModel { MyTicketsViewModel(get()) }
}
